import React from 'react';

import Drawer from '@liquidweb-dev/undercurrent/Drawer';
import DrawerHeader from '@liquidweb-dev/undercurrent/DrawerHeader';

/** @param {import('@liquidweb-dev/undercurrent/Drawer').DrawerProps} props */
const Wrapper = ({ onClose, children, ...rest }) => {
	return (
		<Drawer anchor="right" onClose={onClose} {...rest}>
			<DrawerHeader onClose={onClose}>Image templates</DrawerHeader>
			{children}
		</Drawer>
	);
};

export default Wrapper;
